// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"119e1361","385":"d221cf72","926":"24dcc8e9"}[chunkId] + ".chunk.css";
};